"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/fetchRetry/index.ts
var fetchRetry_exports = {};
__export(fetchRetry_exports, {
  FETCH_RETRIES: () => FETCH_RETRIES,
  FETCH_RETRY_DELAY: () => FETCH_RETRY_DELAY,
  HeaderNames: () => HeaderNames,
  fetchRetry: () => fetchRetry
});
module.exports = __toCommonJS(fetchRetry_exports);

// src/fetchRetry/fetchRetry.ts
var import_fetch_retry = __toESM(require("fetch-retry"));

// src/errors/errors.ts
var OfflineError = class extends Error {
  constructor() {
    super();
    this.name = "OfflineError";
    this.message = "No network was detected on fetch failure";
  }
};
var OwnFetchError = class extends Error {
  constructor(_error) {
    super(_error.message, { cause: _error.cause });
    this.name = _error.name;
  }
};
var AbortError = class extends OwnFetchError {
  constructor() {
    super(new Error("The operation was aborted"));
    this.name = "AbortError";
  }
};
var ensureError = (error) => {
  return error instanceof Error ? error : new Error(String(error));
};

// src/fetchRetry/fetchRetry.ts
var FETCH_RETRIES = 3;
var FETCH_RETRY_DELAY = 1e3;
var retryOn = (attempt, error, response, statusCodes) => {
  const hasStatusOnList = response?.status && statusCodes?.includes(response.status);
  if (!error && !hasStatusOnList) {
    return false;
  }
  if (attempt >= FETCH_RETRIES) {
    return false;
  }
  if (error instanceof AbortError) {
    return false;
  }
  return true;
};
var wrappedFetch = (0, import_fetch_retry.default)(fetch, {
  retries: FETCH_RETRIES,
  retryDelay: FETCH_RETRY_DELAY,
  retryOn
});
var parseResponse = async (response) => {
  return await response.json().then((result) => {
    if ("success" in result && !result.success) {
      return {
        ...result,
        error: new OwnFetchError(result.error)
      };
    }
    return result;
  });
};
var fetchWithConfig = async (input, init = {}, config) => {
  const updatedInit = { ...init };
  if (!config) {
    return await wrappedFetch(input, updatedInit).then(
      (response) => parseResponse(response)
    );
  }
  const timeToExpire = config.timeToExpire ?? 0;
  let timeout = null;
  if (timeToExpire > 0) {
    const abortController = new AbortController();
    timeout = setTimeout(() => {
      abortController.abort(new AbortError());
    }, timeToExpire);
    updatedInit.signal = abortController.signal;
  }
  if (config.retryOnStatusCode) {
    updatedInit.retryOn = (...rest) => retryOn(...rest, config.retryOnStatusCode);
  }
  const result = await wrappedFetch(input, updatedInit).then(
    (response) => config.returnRawResponse ? response : parseResponse(response)
  );
  if (timeout) {
    clearTimeout(timeout);
  }
  return result;
};
var fetchRetry = async (input, init, config) => {
  try {
    return await fetchWithConfig(input, init, config);
  } catch (err) {
    if (typeof navigator !== "undefined" && !navigator.onLine) {
      throw new OfflineError();
    }
    if (err instanceof Error) {
      return {
        success: false,
        // err might be the AbortError, then we should not wrap it once more.
        error: err instanceof OwnFetchError ? err : new OwnFetchError(err)
      };
    } else {
      return {
        success: false,
        error: ensureError(err)
      };
    }
  }
};

// src/fetchRetry/types.ts
var HeaderNames = /* @__PURE__ */ ((HeaderNames2) => {
  HeaderNames2["CONTENT_TYPE"] = "Content-Type";
  HeaderNames2["AUTHORIZATION"] = "Authorization";
  return HeaderNames2;
})(HeaderNames || {});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  FETCH_RETRIES,
  FETCH_RETRY_DELAY,
  HeaderNames,
  fetchRetry
});
